import { keyboardShiftMap } from "./keyboard_shift_map";

var pressedKeys: string[] = [];

/**
 * Returns a standardized key format from a keyboard event.
 */
export function getKeyFromEvent(event: KeyboardEvent) {
  //  Omvandla tangenter med shift till tangent utan shift.
  //  Vi sparar inte resulterande tangenten med skift för att göra det tydliga genom att kunna visa tangenten i stor/liten bokstav med shift före istället,
  //  samt kringgå Capslock.
  let key = event.key;

  if (event.shiftKey) {
    key = withShift(keyboardShiftMap[event.key] ?? event.key);
  }

  return key.toLowerCase();
}

export function isShiftRequired(key: string) {
  return key.toLowerCase().startsWith("shift-");
}

export function withShift(key: string) {
  return "shift-" + key.toLowerCase().replace("shift-", "");
}

export function withoutModifiers(key: string) {
  return key.toLowerCase().replace("shift-", "");
}

document.body.addEventListener('keydown', event => {
  if (!pressedKeys.includes(event.key)) {
    pressedKeys.push(event.key);
  }
}, { capture: true });

document.body.addEventListener('keyup', event => {
  pressedKeys.splice(pressedKeys.indexOf(event.key), 1);
}, { capture: true });

/**
 * Whether a key on the keyboard is pressed.
 * 
 * For debugging, this can be used to better control console logs. For example,
 * to log only during a transition, check whether the shift key is pressed.
 */
export function isKeyPressed(key: 'Shift') {
  return pressedKeys.includes(key);
}